import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import DateInput from '../input/date'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import OptionSelect from 'bstrap-react-mobx-admin/new_src/input/option_select'
import RegionsInput from '../input/regions'
import SelectInput from '../input/select'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import TypeAheadInput from 'bstrap-react-mobx-admin/new_src/input/typeahead'
import moment from 'moment'
import { Helmet } from 'react-helmet'

const FPVCategoriesForm = observer(({ store }) => {
  const entity = store.cv.record
  const origRecord = store.cv.origRecord
  const errors = store.cv.errors
  const updateField = store.cv.updateData.bind(store.cv)
  const { stageOneRestricted, stageTwoRestricted } = store.timeRestriction.checkEntity(store, entity, store.cv.timeRestriction + '_manip')
  const dateRestriction = store.timeRestriction[store.cv.entityname + '_manip']
  const entityDisabled = !store.hasRight(defaultConst.ENTNAMES.FP_CATEGORIES, 'w')
  const disabled = entityDisabled || stageOneRestricted
  const catPlatform = !disabled && store.getCatPlatform(store)
  const catPlatformFilter = !disabled ? store.getCatPlatformFilter(catPlatform) : undefined

  return (
    <div className='row'>
      <Helmet title={store.__(linkConst.LINK_SETTINGS_TITLE).concat(defaultConst.HTML_DIVIDER) + (entity.has('id')
        ? (entity.get('id') ? 'ID ' + entity.get('id') : store.__(defaultConst.TITLE_EDIT))
        : store.__(defaultConst.TITLE_CREATE))} />
      <div className='col-sm-12 col-md-6'>
        {!disabled && <OptionSelect
          attr='platformFilter' label={store.__('platform')} value={catPlatform}
          onChange={store.updateStorageField(store)}
          options={store.options.get('FlyPrivatePlatforms')}
          disabled={disabled} labelattr='text' errors={errors} />}
        <SelectInput
          attr='enum_value' label={store.__('category')} record={entity}
          onChange={updateField} optionsrecord={store.options} valueFilterFc={catPlatformFilter}
          optionsattr='FlyprivateCategories' disabled={disabled}
          labelattr='text' valueattr='value' errors={errors} />
        {disabled
          ? <SelectInput disabled={disabled}
            label={store.__('film')} attr={'video_id'} labelattr='title' valueattr='id'
            record={entity} onChange={updateField} errors={errors}
            optionsrecord={store.options} optionsattr={'films'} />
          : <TypeAheadInput disabled={disabled}
            attr={'video_id'} record={entity} onChange={updateField}
            label={store.__('film')}
            placeholder='start writing to get suggesions ...'
            options={store.options.get('films').map(i => ({ value: i.id, label: i.title }))}
            errors={errors}
            emptyLabel='no match' renderMenuItemChildren={(option, props) => (
              <span key={option.id}>{option.title}</span>
            )} />}
        <TextInput
          disabled={entityDisabled || (stageTwoRestricted && origRecord.valid_to && origRecord.valid_to === entity.get('valid_to'))}
          type='number' label={store.__('order')} attr={'order'}
          record={entity} onChange={updateField} errors={errors} />
        {!entity.has('id')
          ? <RegionsInput store={store} label={store.__('regions')} attr={'regions'}
            record={entity} onChange={updateField}
            errors={errors} disabled={disabled} hideCheckbox
            optionsrecord={store.options} optionsattr={'Countries'} />
          : <SelectInput
            label={store.__('region')} attr={'regions'} labelattr='text' valueattr='value'
            record={entity} onChange={updateField} errors={errors} disabled={disabled}
            optionsrecord={store.options} optionsattr={'Countries'}
            valueFilterFc={store.removeContinents()} />
        }
      </div>
      <div className='col-sm-12 col-md-6'>
        <DateInput
          attr={'valid_from'}
          disabled={disabled || (entity.has('id') && entity.get('valid_from') && moment(entity.get('valid_from')).isSame(moment(), 'day'))}
          errors={errors}
          label={store.__('valid from')}
          minDate={dateRestriction.valid_from.minDate}
          onChange={updateField}
          record={entity} />
        <DateInput
          attr={'valid_to'}
          disabled={entityDisabled || (stageTwoRestricted && origRecord.valid_to && origRecord.valid_to === entity.get('valid_to'))}
          errors={errors}
          label={store.__('valid to')}
          minDate={dateRestriction.valid_to.minDateToday &&
          (!entity.has('id') || (entity.has('valid_from') && entity.get('valid_from') &&
           moment(entity.get('valid_from')).isSameOrAfter(dateRestriction.valid_to.minDateToday, 'day')))
            ? dateRestriction.valid_to.minDateToday
            : dateRestriction.valid_to.minDate}
          onChange={updateField}
          record={entity} />
      </div>
      {!store.manipWarning
        ? ''
        : <div className='col-sm-12'>
          <div className='alert alert-dismissible alert-warning'>
            <p><strong>{store.__('WARNING').concat(': ')}</strong>
              {store.__('World wide (WW) region for this Category is missing (between valid from/to).')}</p>
          </div>
        </div>
      }
      { entity.get('regions') && entity.get('regions') !== 'WW' && entity.get('regions').indexOf(',') > 0 &&
        <div className='col-sm-12'>
          <div className='alert alert-dismissible alert-warning'>
            <p><strong>{store.__('WARNING').concat(': ')}</strong>
              {store.__('Multiple regions will be divided into the separate items.')}
            </p>
          </div>
        </div>
      }
    </div>
  )
})
FPVCategoriesForm.propTypes = {
  store: PropTypes.object.isRequired
}

const FPVCategoriesView = ({ store }) => {
  if (!store.hasRight(defaultConst.ENTNAMES.FP_CATEGORIES)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }
  return (
    <EditView
      store={store.cv}
      onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(defaultConst.ENTNAMES.FP_CATEGORIES, 'w')}>
      <FPVCategoriesForm store={store} />
    </EditView>
  )
}
FPVCategoriesView.propTypes = {
  store: PropTypes.object.isRequired
}

export default FPVCategoriesView
